import React from "react";
import { JHALA_GLOBAL_CSS, TopStrip, Header, Footer, Reveal, TagChip } from "components/jhala/Layout.js";

export default function RefundPolicyPage() {
  return (
    <div style={{ fontFamily: "'Inter', sans-serif", background: "#F6F4EE", color: "#0A0F1E" }}>
      <style>{JHALA_GLOBAL_CSS}</style>
      <TopStrip />
      <Header />

      <section style={{ background: "#0A0F1E", color: "#F6F4EE", padding: "56px 24px 48px" }}>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          <Reveal>
            <TagChip>$ jhalatech --legal refund</TagChip>
            <h1 style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: "clamp(26px, 3.6vw, 38px)", lineHeight: 1.15, margin: "16px 0 0" }}>
              Refund Policy
            </h1>
          </Reveal>
        </div>
      </section>

      <section style={{ padding: "60px 24px 90px", background: "#F6F4EE" }}>
        <div style={{ maxWidth: 800, margin: "0 auto", background: "#FFFFFF", border: "1px solid #DCD8CC", borderRadius: 8, padding: "40px 36px" }}>
          <Reveal>
            <div className="legal-content">
              <p><strong>Effective Date:</strong> July 01, 2025</p>
              <p>
                At JhalaTech, we strive to deliver high-quality IT services and ensure client satisfaction. However, due to the nature of our work, we have outlined the following refund policy to maintain transparency and fairness for both parties.
              </p>

              <h2>1. No Refund Once Work Has Begun</h2>
              <p>
                Once work on a project has commenced, we do not offer full or partial refunds. This includes discovery, planning, design, development, or any other phase of the project.
              </p>

              <h2>2. Exceptions</h2>
              <p>
                In exceptional cases where services were not delivered as agreed or a significant delay occurred solely from our side, a partial refund may be issued. Such decisions are made at our sole discretion.
              </p>

              <h2>3. Subscription-Based Services</h2>
              <p>
                For monthly or annual subscription plans, clients may cancel at any time, but payments already made are non-refundable. Your subscription will remain active until the end of the billing period.
              </p>

              <h2>4. Project Termination by Client</h2>
              <p>
                If the client chooses to terminate the project before completion, no refund will be provided for the work already done or resources allocated. Future milestones or stages not yet started may be reviewed on a case-by-case basis.
              </p>

              <h2>5. Chargebacks</h2>
              <p>
                Filing a chargeback without contacting us first to resolve the issue will be considered a breach of these Terms. We reserve the right to pursue legal action or collection procedures for unjustified chargebacks.
              </p>

              <h2>6. Contact for Refund Queries</h2>
              <p>
                If you believe your case qualifies for a refund or partial compensation, please contact us at:
              </p>
              <ul>
                <li>📧 sales@jhalatech.in</li>
                <li>🌐 www.jhalatech.com</li>
                <li>📍 Indore, Madhya Pradesh, India</li>
              </ul>

              <p><strong>Thank you for trusting JhalaTech. We value our relationship with every client.</strong></p>
            </div>
          </Reveal>
        </div>
      </section>

      <Footer />
    </div>
  );
}
